const games = [
  {
    icon: "game7",
    title: "Emojigeddon",
    description: "Save you heart",
    descriptionFull: "Fully designed, developed and released game. Released exclusively on CrazyGames.com",
    link: "https://www.crazygames.com/game/emojigeddon"
  },
  {
    icon: "game0",
    title: "Crab & Fish",
    description: "Physics and Fun!",
    descriptionFull: "Fully designed, developed and released game. Released on HTML5 game portals.",
    link: "https://poki.com/en/g/crab-and-fish"
  },
  {
   icon: "game1",
   title: "Sly Kittens",
   description: "Classic merge game.",
   descriptionFull: "Fully designed and developed for our partner. Released by publisher on iOS and Android. Was featured in Russian AppStore.",
   link: "https://apps.apple.com/us/app/sly-kittens/id1130268879"
 },
 {
  icon: "game2",
  title: "The Box",
  description: "Time is almost up!",
  descriptionFull: "Christmas challenge for clients of one Insurance company. The refference for that game was `Challenging Bread Simulator in the Samorost world`",
  link: "https://atatapp.games/thebox/"
 },
 {
   icon: "game3",
   title: "InstaGirls",
   description: "Be an Instagram Qeeen!",
   descriptionFull: "The game was developed for our partner.",
   link: "https://kizi.com/games/instagirls-dress-up"
 },
 {
   icon: "game4",
   title: "Fruit Connect 2",
   description: "Literally, connect fruits!",
   descriptionFull: "The game was developed for our partner.",
   link: "https://kizi.com/games/fruit-connect-2"
 },
 {
   icon: "game5",
   title: "Make Me 10",
   description: "Math power!",
   descriptionFull: "Fully designed and developed by us. Released by publisher on HTML5 game portals, iOS and Android.",
   link: "https://keygames.com/make-me-10-game/"
 },
 {
   icon: "game6",
   title: "Beaver Bubbles",
   description: "Classic bubble shooter.",
   descriptionFull: "The game was developed for our partner.",
   link: "https://kizi.com/games/beaver-bubbles"
 }
];

export default games;


